<template>
  <div v-if="show">
    <div class="header">
      <div class="contain header_main">
        <div class="left">
          <div class="logo">
            <img src="../assets/header/logo.png" alt>
          </div>
          <div class="menu">
            <router-link
              tag="div"
              :to="item.path?item.path:item.childrem[0].path"
              v-for="(item,index) in headlist"
              :key="'headMenu'+index"
              v-show="item.show"
              :class="{active:act == index}"
            >
              {{item.name}}
              <ul class="menu_list" v-if="item.childrem.length">
                <router-link
                  :to="sitem.path"
                  v-show="sitem.show"
                  v-for="(sitem,sindex) in item.childrem"
                  :key="'sheader'+sindex"
                  tag="li"
                >{{sitem.name}}</router-link>
              </ul>
            </router-link>
          </div>
        </div>
        <div class="right">
          <Dropdown placement="bottom-start">
            <span>
              <img src="../assets/paper/headimage.png" style="margin-right:19px;">
              {{username}}
              <Icon type="md-arrow-dropdown"/>
            </span>
            <DropdownMenu slot="list">
              <DropdownItem>
                <span @click="exit" class="exit">退出</span>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
    </div>
    <div style="height:0.8rem"></div>
  </div>
</template>

<script>
// 权限及菜单表
var list = [
  {
    name: "考试列表",
    authid: 52,
    path: "/examlists",
    childrem: []
  },
  {
    name: "考试记录",
    authid: 74,
    path: "/examrecords",
    childrem: []
  },
  {
    name: "考试管理",
    authid: null,
    path: null,
    childrem: [
      {
        name: "考试列表",
        authid: 57,
        path: "/managelist",
        childrem: []
      },
      {
        name: "试卷列表",
        authid: 59,
        path: "/manage/publiclist",
        childrem: []
      },
      {
        name: "题库列表",
        authid: 44,
        path: "/manage/issuelist",
        childrem: []
      }
    ]
  },
  {
    name: "统计管理",
    authid: null,
    path: null,
    childrem: [
      {
        name: "人员统计",
        authid: 84,
        path: "/userslist",
        childrem: []
      },
      {
        name: "考试统计",
        authid: 85,
        path: "/examsrecord",
        childrem: []
      }
    ]
  },
  {
    name: "系统设置",
    authid: null,
    path: null,
    childrem: [
      {
        name: "用户管理",
        authid:  20,
        path: "/managerlist",
        childrem: []
      },
      {
        name: "角色管理",
        authid: 26,
        path: "/powerlist",
        childrem: []
      },
      {
        name: "分类管理",
        authid: 39,
        path: "/classmanage",
        childrem: []
      },
      {
        name: "知识点管理",
        authid: 96,
        path: "/knowledgePoints",
        childrem: []
      }
    ]
  }
];
import { loginOut, Login_menu } from "../assets/js/api.js";
import { clearLoginState } from "../assets/js/auth.js";
// import store from '../store/index.js';
export default {
  name: "Header",
  data() {
    return {
      username: "",
      classmap: new Map(),
      headlist: [],
      show:true
    };
  },
  mounted() {
    if (window.sessionStorage.getItem("type") == "0"||window.sessionStorage.getItem("type") == "1") {
      this.username = window.localStorage.getItem("username");
      if (window.sessionStorage.getItem("headmenu")) {
        this.headlist = JSON.parse(window.sessionStorage.getItem("headmenu"));
      } else {
        this.getlist();
      }
    } else {
      this.show=false
    }
  },
  computed: {
    act() {
      // switch (this.$route.path) {
      //   case "/examlists":
      //     return 0;
      //     break;
      //   case "/examrecords":
      //     return 1;
      //     break;
      //   case "/managelist":
      //     return 2;
      //     break;
      // }
      return this.toact(this.$route.path);
    }
    // 弃用vuex，用本地存储
    // username(){
    //   return this.$store.state.username
    // }
  },
  methods: {
    toact(data) {
      for (var i = 0; i < this.headlist.length; i++) {
        if (
          this.headlist[i].path == data ||
          this.headlist[i].childrem.some(item => {
            return item.path == data;
          })
        ) {
          return i;
        }
      }
    },
    exit() {
      const SSO_LOGOUT =
        "https://passport.lenovo.com/webauthn/preLogin?webauthn_action=uilogout&webauthn_realm=exam.lenovo.com.cn&webauthn_lang=null&webauthn_callback=https://exam.lenovo.com.cn/api/Login/callback&webauthn_state=null";
      // 1. 先清本地登录信息
      clearLoginState();
      // 2. 清后端 Session，再跳转 passport 登出
      loginOut()
        .then(res => {
          const ssoUrl = (res.data && res.data.data && res.data.data.ssoLogoutUrl) || SSO_LOGOUT;
          window.location.replace(ssoUrl);
        })
        .catch(() => {
          window.location.replace(SSO_LOGOUT);
        });
    },
    getlist() {
      Login_menu().then(res => {
        // this.$router.push("/examlists");
        if (res.data.code == 200) {
          this.headlist = list.map(item => {
            if (
              item.authid == null ||
              res.data.data[0].rules.indexOf(item.authid + "") != -1
            ) {
              item.show = true;
            } else {
              item.show = false;
            }
            if (item.childrem.length > 0) {
              item.childrem = item.childrem.map(sitem => {
                console.log(sitem.name)
                if (res.data.data[0].rules.indexOf(sitem.authid + "") != -1) {
                  sitem.show = true;
                } else {
                  sitem.show = false;
                }
                return sitem;
              });
              item.show = item.childrem.some(sitem => {
                return sitem.show == true;
              });
            }
            return item;
          });
          window.sessionStorage.setItem(
            "headmenu",
            JSON.stringify(this.headlist)
          );
          //this.$store.commit('setheadlist',headlist)
          return;
        }
        this.$notice.success({ title: "信息提示", desc: res.data.message });
      });
    }
  }
};
</script>
<style scoped>
.header {
  height: 0.8rem;
  width: 100%;
  border-bottom: #e8e9ee 1px solid;
  background: #fff;
  position: fixed;
  top: 0;
  z-index: 10000;
  /* border: 1px solid red; */
}
.header_main {
  height: 0.8rem;
  display: flex;
  justify-content: space-between;
  line-height: 0.8rem;
}
.logo {
  width: 1.84rem;
  height: 0.4rem;
  display: inline-block;
  line-height: 0.4rem;
  margin-top: 0.2rem;
}
.left {
  display: flex;
  justify-content: space-between;
  width: 9.8rem;
}
.logo img {
  width: 100%;
  height: 100%;
}
.menu {
  display: flex;
  width: 7rem;
  user-select: none;
}
.menu > div {
  margin: 0 0.2rem;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: #666;
  position: relative;
  cursor: pointer;
  font-weight: 600;
}
.menu > div:hover {
  color: #474dff;
}
.menu > div.active {
  color: #474dff;
}
.right {
  width: 1.8rem;
  height: 0.8rem;
  border-left: 1px solid #e8e9ee;
  color: #464646;
  cursor: pointer;
}
.exit {
  width: 1.2rem;
  height: 0.3rem;
  line-height: 0.3rem;
  text-align: center;
  display: inline-block;
}
.menu_list {
  width: 120px;
  padding: 10px;
  line-height: 30px;
  background: #fff;
  z-index: 1000;
  position: absolute;
  top: 60px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  box-shadow: 0 0 20px 0 rgb(197, 193, 193);
  border-radius: 10px;
  color: #464646;
  font-weight: normal;
  font-size: 14px;
  display: none;
}
.menu > div:hover .menu_list {
  display: block;
}
.menu_list li:hover {
  background: #a9abecb4;
  border-radius: 3px;
  color: #fff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue